// Google sign-in screen (raw Google Identity Services, like florence — no npm dep).
// Visual match to florence's DevLogin: cream full-screen with an interactive DotField, the Hekavor
// logo centered, and a "Research" title below it, with the Google button underneath.
// On a successful Google credential it exchanges it for an app JWT via POST /auth/google, then hands
// the app token to the auth gate (onLogin). Authorization (whitelist/domain) is enforced server-side;
// a rejected email surfaces here as an inline error.
import React, { useEffect, useRef, useState } from "react";
import { googleLogin } from "../services/api";
import DotField from "./DotField";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export default function Login({ onLogin }) {
  const btnRef = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const handleCredential = async (resp) => {
      setError("");
      try {
        const data = await googleLogin(resp.credential); // { email, access_token, token_type }
        if (data?.access_token) onLogin(data.access_token);
      } catch (e) {
        setError(e?.response?.data?.detail || "Sign-in failed. Please try again.");
      }
    };
    const init = () => {
      if (!window.google?.accounts?.id || !btnRef.current) return;
      window.google.accounts.id.initialize({ client_id: CLIENT_ID, callback: handleCredential });
      window.google.accounts.id.renderButton(btnRef.current, { theme: "outline", size: "large", width: 300 });
    };
    if (window.google?.accounts?.id) { init(); return undefined; }
    let script = document.getElementById("gsi-script");
    if (!script) {
      script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.id = "gsi-script";
      document.body.appendChild(script);
    }
    script.addEventListener("load", init);
    return () => script.removeEventListener("load", init);
  }, [onLogin]);

  return (
    <div style={{ position: "fixed", inset: 0, overflow: "hidden", background: "#faf9f6", display: "grid", placeItems: "center" }}>
      <div style={{ position: "absolute", inset: 0 }} aria-hidden="true">
        <DotField />
      </div>
      <div style={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center", gap: "30px" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
          <img
            src="/hekavor-logo.svg"
            alt="Hekavor"
            draggable="false"
            style={{ width: "min(240px, 40vw)", height: "auto", userSelect: "none", pointerEvents: "none" }}
          />
          <div style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontSize: "20px", letterSpacing: "0.34em", textTransform: "uppercase", color: "#6b6470", paddingLeft: "0.34em" }}>
            Research
          </div>
        </div>
        <div ref={btnRef} style={{ display: "flex", justifyContent: "center", minHeight: 44 }} />
        {error && <div className="banner bad" style={{ maxWidth: 300 }}>{error}</div>}
      </div>
    </div>
  );
}
